import { Fade, MenuItem } from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import MenuItemText from '../MenuItemText';
import { AppMenuItem } from './types';

interface MobileMenuItemProps {
    menuItem: AppMenuItem;
    onCloseNavMenu: () => void;
    index?: number;
}

/**
 * Mobile menu item component with staggered animation
 */
const MobileMenuItem: FC<MobileMenuItemProps> = ({ menuItem, onCloseNavMenu, index = 0 }) => {
    const handleClick = () => {
        onCloseNavMenu();
        if (menuItem.link.startsWith('http')) {
            window.open(menuItem.link, '_blank', 'noopener,noreferrer');
        }
    };

    const animationDelay = index * 50; // Staggered animation delay

    if (menuItem.link.startsWith('http')) {
        return (
            <Fade in timeout={300 + animationDelay}>
                <MenuItem
                    key={menuItem.name}
                    onClick={handleClick}
                    sx={{
                        my: 2,
                        display: 'block'
                    }}
                >
                    <MenuItemText context="dropdown">{menuItem.name}</MenuItemText>
                </MenuItem>
            </Fade>
        );
    }

    return (
        <Fade in timeout={300 + animationDelay}>
            <MenuItem
                key={menuItem.name}
                onClick={onCloseNavMenu}
                component={Link}
                to={menuItem.link}
            >
                <MenuItemText context="dropdown" textAlign="center">
                    {menuItem.name}
                </MenuItemText>
            </MenuItem>
        </Fade>
    );
};

export default MobileMenuItem;
